import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Il servizio è davvero gratuito?",
    a: "Sì, il nostro servizio è completamente gratuito e senza impegno. I fornitori di pannelli solari della tua zona competono tra loro per offrirti il miglior preventivo. Non dovrai pagare nulla per utilizzare la nostra piattaforma.",
  },
  {
    q: "Quanto costa un impianto fotovoltaico?",
    a: "Il costo dipende dalla dimensione dell'impianto e dalla tipologia. Un impianto residenziale da 3kW parte da circa 5.000€, mentre uno da 6kW può costare tra 8.000€ e 12.000€. Con le detrazioni fiscali al 50%, il costo effettivo si dimezza.",
  },
  {
    q: "In quanto tempo si ripaga l'investimento?",
    a: "Mediamente un impianto fotovoltaico si ripaga in 5-7 anni, considerando il risparmio in bolletta e le detrazioni fiscali. Dopo questo periodo, l'energia prodotta è praticamente gratuita per i successivi 18-20 anni.",
  },
  {
    q: "Posso installare pannelli solari sul mio condominio?",
    a: "Assolutamente sì! Con le comunità energetiche rinnovabili (CER), è possibile installare pannelli solari sul tetto condominiale e condividere i benefici tra tutti i condomini. Servono le necessarie autorizzazioni assembleari.",
  },
  {
    q: "Quali incentivi statali sono disponibili?",
    a: "Attualmente sono disponibili le detrazioni fiscali al 50% per impianti residenziali, il Piano Transizione 5.0 per le aziende, e gli incentivi GSE per le comunità energetiche. Ogni situazione può avere agevolazioni specifiche.",
  },
  {
    q: "Come funziona la verifica OTP del numero di telefono?",
    a: "Per garantire la qualità dei preventivi, verifichiamo il tuo numero di telefono tramite un codice OTP inviato via SMS. Questo processo protegge te e i fornitori, assicurando che solo richieste genuine vengano elaborate.",
  },
  {
    q: "Quanto dura un impianto fotovoltaico?",
    a: "I pannelli solari moderni hanno una durata di vita media di 25-30 anni con una garanzia di produzione che copre almeno l'80% della potenza iniziale dopo 25 anni. L'inverter ha generalmente una garanzia di 10-15 anni.",
  },
  {
    q: "Serve manutenzione per i pannelli solari?",
    a: "La manutenzione è minima. Si consiglia una pulizia annuale dei pannelli e un controllo dell'impianto ogni 2-3 anni. Molti installatori offrono contratti di manutenzione inclusi nel prezzo di installazione.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="py-20 sm:py-28 bg-white" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-20">
          <div className="lg:col-span-1">
            <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wide">FAQ</span>
            <h2
              className="mt-3 text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight"
              style={{ fontFamily: "Outfit, sans-serif" }}
              data-testid="faq-title"
            >
              Domande Frequenti
            </h2>
            <p className="mt-4 text-slate-500 text-base leading-relaxed">
              Trova le risposte alle domande più comuni sul fotovoltaico e il nostro servizio di confronto preventivi.
            </p>
            <div className="mt-8 p-5 rounded-2xl bg-emerald-50 border border-emerald-100">
              <p className="text-sm text-emerald-800 font-medium mb-1">Hai altre domande?</p>
              <p className="text-sm text-emerald-600">
                Contattaci a{" "}
                <a href="mailto:info@fotovoltaicochiavimano.it" className="underline font-semibold">
                  info@fotovoltaicochiavimano.it
                </a>
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  className="border-b border-slate-100"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left text-base font-semibold text-slate-900 hover:text-emerald-600 py-5 hover:no-underline">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-slate-500 leading-relaxed pb-5">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
